import React from 'react';

/** Material UI Packages. */
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

/** Create tabPanel component. */
export default function TabPanel({ children, value, index, boxStyle, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} {...other}>
            {value === index && (
                <Box sx={{ p: 0, ...boxStyle }}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

/** To run typechecking on the props for a component. */
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
